import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

export interface ChipItem<T extends string = string> {
  key: T;
  label: string;
}

interface PropsFilterChips<T extends string> {
  items: ChipItem<T>[];
  active: T;
  onChange: (key: T) => void;
  className?: string;
}

export default function FilterChips<T extends string>({
  items,
  active,
  onChange,
  className,
}: PropsFilterChips<T>) {
  return (
    <div className={cn('flex flex-wrap gap-quark', className)}>
      {items.map((it) => {
        const isActive = it.key === active;
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => onChange(it.key)}
            className={cn(
              'h-[34px] px-smaller rounded-full border transition-colors',
              isActive
                ? 'bg-primary-01 border-primary-01 text-intense-01'
                : 'bg-intense-01 border-intense-03 text-intense-07',
            )}
          >
            <Text
              className={cn(
                'text-captionLG',
                isActive ? 'color-intense-01' : 'color-intense-07',
              )}
            >
              {it.label}
            </Text>
          </button>
        );
      })}
    </div>
  );
}
